function getValue(val) {
  if (val && val !== Infinity) return val;
  return 0;
}

module.exports = {
  getValue: function (val) {
    if (val && val !== Infinity) return val;
    return 0;
  },
  getPositiveValueOnly: function (val) {
    if (val && val !== Infinity && val > 0) return val;
    return 0;
  },
  sum: function(...inputs) {
    const output = new Array(inputs[0].length);
    for (let i=0; i<output.length; i++) {
      let total = 0;
      inputs.forEach(function(input) {
        total += input[i];
      });
      output[i] = total;
    }
    return output;
  },
  difference: function(...inputs) {
    const output = new Array(inputs[0].length);
    for (let i=0; i<output.length; i++) {
      const input = inputs[i];
      let total = inputs[0][i];

      for(let j=1; j<inputs.length; j++) {
        total -= inputs[j][i];
      }

      output[i] = total;
    }
    return output;
  },
  divide: function (dividend, divisor) {
    const output = new Array(dividend.length);
    for (let i=0; i<output.length; i++) {
      output[i] = getValue(dividend[i]/divisor[i]);
    }
    return output;
  },
  percentage: function (dividend, divisor) {
    const output = new Array(dividend.length);
    for (let i=0; i<output.length; i++) {
      output[i] = getValue((dividend[i]/divisor[i])*100);
    }
    return output;
  },
  childrenIds: function (id, data) {
    const output = [];
    data.forEach(element => {
      if (element.parent == id) output.push(element.id);
    });
    return output;
  },
  onlyPositiveDifference: function(input1, input2) {
    const output = new Array(input1.length);
    for (let i=0; i<output.length; i++) {
      output[i] = (input1[i] > input2[i]) ? input1[i] - input2[i] : 0;
    }
    return output;
  },
  multiplyParameter: function (valuesArr, parameter) {
    const output = new Array(valuesArr.length);
    for (let i=0; i<output.length; i++) {
      output[i] = valuesArr[i] * parameter;
    }
    return output;
  }
};



// WEBPACK FOOTER //
// ./src/cma/cmaOperations.js